// extracted by mini-css-extract-plugin
export var bottom = "rip-module--bottom--281f3";
export var rip = "rip-module--rip--58c85";
export var top = "rip-module--top--51281";